import { FC } from "react";
import styled from "@emotion/styled";
import { MDSCard, MDSCardSlotName } from "@/mds/components/card";

import { IntegrationItem } from "@/pages/integrations/integrations-page.types";
import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";

export interface Props {
  title: string;
  items: IntegrationItem[];
}

export const IntegrationsSection: FC<Props> = ({ title, items }) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <Title>{title}</Title>
      <Container>
        {items.map(item => (
          <CardWrapper key={item.type}>
            <IntegrationCard
              key={item.type}
              title={item.title}
              mdsIcon={item.icon}
              description={item.description}
              onPress={item.onPress}
              isDisabled={!item.isAllowed}
            >
              {item.isEnabled && (
                <StatusBadge slot={MDSCardSlotName.RightAddon}>
                  <MdsIcon kind={MdsIconKind.CheckCircleSolid} />
                </StatusBadge>
              )}
            </IntegrationCard>
          </CardWrapper>
        ))}
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
`;

const CardWrapper = styled.div`
  width: 300px;
  height: 100px;
`;

const Title = styled.h2`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  margin: ${({ theme }) => theme.spacing.xs} 0;
  color: ${({ theme }) => theme.colors.grey.x600};
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.md};
  flex-wrap: wrap;
`;

const StatusBadge = styled.span`
  & svg {
    color: ${({ theme }) => theme.colors.green.x400};
  }
`;

const IntegrationCard = styled(MDSCard)`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-start;

  & > div {
    width: 100%;
  }
`;
